// Детекция «кириллицы-двойника» в артикуле на фронте (живая, на каждый ввод).
// Зеркало backend-логики normalizeArtKey: кириллические буквы, визуально равные
// латинским, в смешанной строке — подделка; чисто русские артикулы не трогаем.
//
// Сравнение confusable идёт по ВЕРХНЕМУ регистру, поэтому ловятся и строчные
// двойники (нм → HM), но для подсветки красим именно ИСХОДНЫЕ буквы.

// Кириллическая заглавная → латинская. Проверяем символ через .toUpperCase(),
// поэтому строчные сюда включать не нужно.
const CYR_TO_LAT: Record<string, string> = {
  А: 'A',
  В: 'B',
  Е: 'E',
  К: 'K',
  М: 'M',
  Н: 'H',
  О: 'O',
  Р: 'P',
  С: 'C',
  Т: 'T',
  У: 'Y',
  Х: 'X',
}
const CONFUSABLE = new Set(Object.keys(CYR_TO_LAT))
const CYRILLIC = /[Ѐ-ӿ]/
const LATIN = /[A-Za-z]/

// Кириллический символ-двойник (любой регистр).
function isConfusable(ch: string): boolean {
  return CYRILLIC.test(ch) && CONFUSABLE.has(ch.toUpperCase())
}

export type HomoglyphSeg = { text: string; bad: boolean }

export interface HomoglyphInfo {
  /** true только если строка смешанная и все кириллические буквы — confusable. */
  has: boolean
  /** Сегменты для рендера: bad=true → красная подсветка (кириллица-двойник). */
  segments: HomoglyphSeg[]
  /** Уникальные «плохие» кириллические буквы (для текста-пояснения). */
  letters: string[]
  /** Латинская (каноническая) версия артикула (в верхнем регистре). */
  canonical: string
}

export function detectHomoglyph(input: string | null | undefined): HomoglyphInfo {
  const s = input ?? ''
  const none: HomoglyphInfo = {
    has: false,
    segments: [{ text: s, bad: false }],
    letters: [],
    canonical: s,
  }
  if (!s || !LATIN.test(s) || !CYRILLIC.test(s)) return none
  // Хоть одна «настоящая» русская буква (не confusable) → легитимный русский
  // артикул, не трогаем.
  for (const ch of s) {
    if (CYRILLIC.test(ch) && !CONFUSABLE.has(ch.toUpperCase())) return none
  }

  const segments: HomoglyphSeg[] = []
  const letters = new Set<string>()
  let canonical = ''
  for (const ch of s) {
    const bad = isConfusable(ch)
    canonical += bad ? (CYR_TO_LAT[ch.toUpperCase()] ?? ch.toUpperCase()) : ch.toUpperCase()
    if (bad) letters.add(ch)
    const last = segments[segments.length - 1]
    if (last && last.bad === bad) last.text += ch
    else segments.push({ text: ch, bad })
  }
  return { has: true, segments, letters: [...letters], canonical }
}
